// TODO: deixar uma lib de qrcode e input-mask só. não precisa de 2!
// TODO: add suspense e error boundary (granular, específico para cada componente): https://certificates.dev/blog/error-handling-in-react-with-react-error-boundary
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-contexify/dist/ReactContexify.css';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import './styles.module.css';
import Routes from './routes';
import customHistory from './services/history';
import { store, persistor } from './store';

if (process.env.REACT_APP_ENV === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // enableLogs: process.env.NODE_ENV === 'production', // talvez eu teste isso como true no futuro
    // Known third-party noise (Outlook SafeLinks crawler, browser extensions, etc.)
    // that produce unhandled rejections unrelated to our application code.
    // ignoreErrors: [
    //   // MS Outlook SafeLinks / Office link preview crawler
    //   // https://github.com/getsentry/sentry-javascript/issues/3440
    //   'Object Not Found Matching Id:',
    //   // Benign ResizeObserver warnings fired by the browser itself
    //   'ResizeObserver loop limit exceeded',
    //   'ResizeObserver loop completed with undelivered notifications',
    //   // Chrome/iOS Google Translate injects minified scripts that reject
    //   // promises with 1–3 letter messages (e.g. "Ba", "$a"). Not our code.
    //   /^[A-Za-z$]{1,3}$/,
    //   // iOS Safari media quirks when tapping/seeking <video> before metadata
    //   // is ready or when play() is interrupted by slide change (FileCarousel).
    //   'IndexSizeError: The index is not in the allowed range.',
    //   'The index is not in the allowed range.',
    //   'AbortError: The operation was aborted.',
    //   'The operation was aborted.',
    // ],
    denyUrls: [
      // Browser extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,
      // Google Translate (Chrome auto-translate / extension)
      /translate\.googleapis\.com/i,
      /translate\.google\.com/i,
      /translate\.googleusercontent\.com/i,
    ],
  });
  // eslint-disable-next-line no-console
  console.log('Sentry enabled for production environment');
}

ReactDOM.render(
  // <GlobalErrorBoundary>
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Router history={customHistory}>
        <Routes />
        <ToastContainer position="top-center" autoClose={2000} />
      </Router>
    </PersistGate>
  </Provider>,
  // </GlobalErrorBoundary>,
  document.getElementById('root')
);
